var giphy_viewer_default = {
  "giphyWrapper": "cnrWH",
  "giphy_player": "uMv8Q",
  "playIcon": "_0LC8x",
  "gifRatio": "yyJJJ"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
